/* homeshape – Hero-Lichtschalter, NFC-Demo, Produkt-Konfigurator, Hell/Dunkel */
(function(){
"use strict";

/* ---------- Helfer ---------- */
function rgb(h){ const n = parseInt(h.slice(1), 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
function mix(a, b, k){ const x = rgb(a), y = rgb(b); return "#" + x.map((v,i) => Math.round(v*(1-k) + y[i]*k).toString(16).padStart(2,"0")).join(""); }
function lum(h){ const c = rgb(h).map(v => { v /= 255; return v <= .03928 ? v/12.92 : ((v+.055)/1.055) ** 2.4; }); return .2126*c[0] + .7152*c[1] + .0722*c[2]; }
function contrast(a,b){ const [x,y] = [lum(a), lum(b)].sort((p,q) => q-p); return (x+.05)/(y+.05); }
function hue(h){ const [r,g,b] = rgb(h).map(v => v/255); const mx = Math.max(r,g,b), mn = Math.min(r,g,b); if (mx - mn < .04) return null; const d = mx-mn; let H;
  if (mx === r) H = ((g-b)/d) % 6; else if (mx === g) H = (b-r)/d + 2; else H = (r-g)/d + 4; return (H*60 + 360) % 360; }
/* ---------- Hell / Dunkel ---------- */
function initTheme(){
  const btns = document.querySelectorAll("[data-hs-theme-toggle]");
  const label = () => document.documentElement.getAttribute("data-theme") === "dark" ? "Hellen Modus einschalten" : "Dunklen Modus einschalten";
  btns.forEach(b => {
    b.setAttribute("aria-label", label());
    b.addEventListener("click", () => {
      const t = document.documentElement.getAttribute("data-theme") === "dark" ? "light" : "dark";
      document.documentElement.setAttribute("data-theme", t);
      try { localStorage.setItem("hs-theme", t); } catch(e){}
      btns.forEach(x => x.setAttribute("aria-label", label()));
    });
  });
}

/* ---------- Hero ---------- */
function initHero(root){
  const sw = root.querySelector("[data-hs-switch]"), lbl = root.querySelector("[data-hs-switch-label]");
  const cta = root.querySelector("[data-hs-hero-cta]"), stage = root.querySelector("[data-hs-hero-stage]");
  let on = false;
  const photos = () => root.querySelectorAll("[data-hs-hero-photo] .hs-photo");
  sw && sw.addEventListener("click", () => {
    on = !on; root.classList.toggle("glowing", on); sw.setAttribute("aria-pressed", on);
    lbl.textContent = on ? "Licht einschalten" : "Licht ausschalten";
    photos().forEach(p => p.classList.toggle("on", on));
  });
  root.querySelectorAll("[data-hs-dot]").forEach(b => b.addEventListener("click", () => {
    const c = b.dataset.hsDot;
    root.querySelectorAll("[data-hs-dot]").forEach(x => x.setAttribute("aria-pressed", x === b));
    root.querySelectorAll("[data-hs-hero-photo]").forEach(p => { p.hidden = p.dataset.hsHeroPhoto !== c; });
    if (cta) cta.href = cta.href.replace(/products\/[^/?#]+/, "products/" + c);
    if (stage) stage.setAttribute("aria-label", "Foto eines Reliefs: " + b.dataset.name);
  }));
}

/* ---------- NFC-Tabs ---------- */
function initNfc(root){
  const tabs = root.querySelectorAll("[data-hs-tab]");
  tabs.forEach(t => t.addEventListener("click", () => {
    tabs.forEach(x => x.setAttribute("aria-selected", x === t));
    root.querySelectorAll("[data-hs-screen]").forEach(s => s.classList.toggle("active", s.dataset.hsScreen === t.dataset.hsTab));
  }));
}

/* ---------- Produkt-Konfigurator ---------- */
function initProduct(root){
  const handle = root.dataset.handle, isCountry = root.dataset.country === "true";
  const currency = root.dataset.currency || "EUR";
  let variants = [];
  try { variants = JSON.parse(root.querySelector("[data-hs-variants]").textContent); } catch(e){}
  const form = root.querySelector("[data-hs-form]");
  const fields = [...root.querySelectorAll("[data-hs-option]")];
  const idInput = root.querySelector("[data-hs-variant]");
  const priceEl = root.querySelector("[data-hs-price]"), addBtn = root.querySelector("[data-hs-add]");
  const stage = root.querySelector("[data-hs-stage]"), frame = root.querySelector("[data-hs-frame]");
  const photoSlot = root.querySelector("[data-hs-photo-slot]"), svgSlot = root.querySelector("[data-hs-svg-slot]");
  const note = root.querySelector("[data-hs-note]"), wall = root.querySelector("[data-hs-wall]"), advice = root.querySelector("[data-hs-advice]");
  const dayBtn = root.querySelector("[data-hs-day]"), nightBtn = root.querySelector("[data-hs-night]");
  const colorField = fields.find(f => f.dataset.isColor === "true");
  let night = false;

  const fmt = cents => { const v = cents / 100; return v.toLocaleString("de-DE", { style:"currency", currency, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits:2 }); };
  const selected = () => fields.map(f => { const c = f.querySelector("input:checked"); return c ? c.value : null; });
  const find = opts => variants.find(v => v.options.every((o, i) => o === opts[i]));

  function colorInfo(){
    if (!colorField) return { name:"", hex:"#EFE8D2", glow:true };
    const c = colorField.querySelector("input:checked");
    return { name:c.value, hex:c.dataset.hex, glow:/elfenbein/i.test(c.value) };
  }
  function sizeIsLarge(){ return selected().some(v => v && /large|xl/i.test(v)); }

  function recommend(wallHex){
    if (!colorField) return null;
    let best = null, score = -1e9; const wh = hue(wallHex);
    colorField.querySelectorAll("input").forEach(inp => {
      const hex = inp.dataset.hex; let s = -Math.abs(Math.log(contrast(wallHex, hex)) - Math.log(3.2));
      const ch = hue(hex);
      if (wh !== null && ch !== null){ const dh = Math.min(Math.abs(wh-ch), 360-Math.abs(wh-ch)); s -= dh > 150 ? 0 : dh/400; }
      if (s > score){ score = s; best = inp; }
    });
    return best;
  }

  function renderStage(){
    if (!stage) return;
    const c = colorInfo();
    if (wall) stage.style.background = wall.value;
    stage.classList.toggle("dark", night);
    const usePhoto = !isCountry || c.glow;
    if (usePhoto){
      photoSlot.hidden = false; svgSlot.hidden = true;
      const p = photoSlot.querySelector(".hs-photo"); if (p) p.classList.toggle("on", night);
    } else {
      // Echtes Foto in der gewählten Farbe einfärben (Form und Schattierung bleiben erhalten)
      photoSlot.hidden = true; svgSlot.hidden = false;
      const src = photoSlot.querySelector(".hs-photo .d");
      let tint = svgSlot.querySelector(".hs-tint");
      if (!tint && src){
        tint = document.createElement("div"); tint.className = "hs-tint";
        tint.style.width = photoSlot.querySelector(".hs-photo").style.width;
        tint.style.setProperty("--hs-mask", 'url("' + (src.currentSrc || src.src) + '")');
        const img = document.createElement("img"); img.src = src.currentSrc || src.src; img.alt = "";
        tint.appendChild(img); svgSlot.appendChild(tint);
      }
      if (tint){ tint.style.backgroundColor = c.hex; tint.classList.toggle("night", night); }
    }
    frame.style.width = sizeIsLarge() ? "92%" : "74%";
    if (note) note.textContent = night ? (c.glow ? "Nacht – Elfenbein leuchtet nach" : "Nacht – nur Elfenbein leuchtet") : (sizeIsLarge() ? "Extra Large an deiner Wand" : "Standard an deiner Wand");
    if (advice && wall){
      const rec = recommend(wall.value);
      if (rec){
        advice.innerHTML = "";
        const s = document.createElement("strong"); s.textContent = "Empfehlung: " + rec.value + ". ";
        advice.appendChild(s);
        if (rec.checked) advice.appendChild(document.createTextNode("Ist schon ausgewählt."));
        else { const b = document.createElement("button"); b.type = "button"; b.textContent = "Übernehmen"; b.onclick = () => { rec.checked = true; update(); }; advice.appendChild(b); }
      }
    }
    const cn = root.querySelector("[data-hs-colorname]"); if (cn && c.name) cn.textContent = "· " + c.name;
  }

  function update(){
    const sel = selected();
    const v = find(sel);
    // Preisunterschiede und nicht verfügbare Kombinationen
    fields.forEach((f, i) => f.querySelectorAll("input").forEach(inp => {
      const opts = sel.slice(); opts[i] = inp.value;
      const alt = find(opts);
      inp.disabled = !alt;
      const small = inp.parentElement.querySelector("[data-hs-diff]");
      if (small){ const d = alt && v ? alt.price - v.price : 0; small.textContent = alt ? (d > 0 ? "+" + fmt(d) : "") : "nicht verfügbar"; }
    }));
    if (v){
      idInput.value = v.id;
      priceEl.textContent = fmt(v.price);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? "In den Warenkorb" : "Ausverkauft";
      try { const u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u); } catch(e){}
    } else {
      addBtn.disabled = true; addBtn.textContent = "Nicht verfügbar";
    }
    renderStage();
  }

  form && form.addEventListener("change", e => { if (e.target.name && e.target.name.startsWith("hs-o")) update(); });
  wall && wall.addEventListener("input", renderStage);
  dayBtn && dayBtn.addEventListener("click", () => { night = false; dayBtn.setAttribute("aria-pressed", true); nightBtn.setAttribute("aria-pressed", false); renderStage(); });
  nightBtn && nightBtn.addEventListener("click", () => { night = true; nightBtn.setAttribute("aria-pressed", true); dayBtn.setAttribute("aria-pressed", false); renderStage(); });
  update();
}

function hsInit(){
  initTheme();
  document.querySelectorAll("[data-hs-hero]").forEach(initHero);
  document.querySelectorAll("[data-hs-nfc]").forEach(initNfc);
  document.querySelectorAll("[data-hs-product]").forEach(initProduct);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", hsInit); else hsInit();
/* Theme-Editor: Sektion neu geladen */
document.addEventListener("shopify:section:load", e => {
  e.target.querySelectorAll("[data-hs-hero]").forEach(initHero);
  e.target.querySelectorAll("[data-hs-nfc]").forEach(initNfc);
  e.target.querySelectorAll("[data-hs-product]").forEach(initProduct);
});

})();
